import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './Container.less';
import { useAnimatePortal } from '@byted-bricks/use-modal';
import Header from '../components/HeaderForPC';
import Footer from '../components/FooterForPC';
import BaseContainer from '../components/BaseContainer';
import useContainData from '~/common/hooks/useContainData';
import MediaPop from '~/components/allPop/mediaPop';
import { downloadImage } from '~/utils/downImg';
import { logBigPic, logDownPic } from '~/utils/log';
import { customRedirect } from '~/utils/link/goPage';
import { getSpecFont } from '~/utils/fontClass/index';
import useAreaLimit from '~/common/hooks/useAreaLimit';
import DomainLimit from '~/components/domainLimit';

export default function Container() {
  const { t, i18n } = useTranslation();

  const mediaLabels: {
    [key: string]: string;
  } = useMemo(() => {
    return {
      ALL: t('all'),
      LOGOS: t('logos'),
      VIDEOS: t('videos'),
      ART: t('art'),
      OTHERS: t('others')
    };
  }, [t]);
  const { isLimit } = useAreaLimit();
  const { getCurrentData } = useContainData();
  const [mediaListTab] = useState(['ALL', 'LOGOS', 'VIDEOS', 'ART', 'OTHERS']);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [currentTabName, setTabName] = useState('ALL');
  const [ShowMediaPop, toggle_MediaPop, , CloseMediaPop] = useAnimatePortal();
  const [mediaData, setMediaData] = useState({});

  const handleSelectTab = (item, index) => {
    setTabName(item);
    setCurrentTabIndex(index);
  };

  const onProcessData = useCallback(() => {
    const mediaAllList = [
      {
        title: 'LOGOS',
        titleList: [],
        description: 'LOGOS'
      },
      { title: 'VIDEOS', titleList: [], description: 'VIDEOS' },
      { title: 'ART', titleList: [], description: 'ART' },
      { title: 'OTHERS', titleList: [], description: 'OTHERS' }
    ];
    const sliceMediaAllList = [
      {
        title: 'LOGOS',
        titleList: [],
        description: 'LOGOS'
      },
      { title: 'VIDEOS', titleList: [], description: 'VIDEOS' },
      { title: 'ART', titleList: [], description: 'ART' },
      { title: 'OTHERS', titleList: [], description: 'OTHERS' }
    ];
    mediaAllList.forEach((item) => {
      getCurrentData(0)
        ?.filter((mediaCur) => mediaCur.description === item.title)
        .forEach((curIt) => {
          item.titleList.push(curIt);
        });

      // console.log(mediaAllList, 'mediaAllList');
    });
    if (currentTabName === 'ALL') {
      sliceMediaAllList.forEach((item) => {
        getCurrentData(0)
          ?.filter((mediaCur) => mediaCur.description === item.title)
          .forEach((curIt, idx) => {
            if (idx < 3) {
              item.titleList.push(curIt);
            }
          });

        // console.log(mediaAllList, 'mediaAllList');
      });
      return sliceMediaAllList;
    } else {
      return mediaAllList.filter((it) => it.description === currentTabName);
    }
  }, [currentTabName, getCurrentData]);
  const handleOnUrl = (oneSource) => {
    const isNum = /^[0-9]+.?[0-9]*/.test(oneSource?.url);

    logBigPic(`${oneSource?.description}-${oneSource?.id}`);

    if (oneSource.url === '') {
      // message.success(`${oneSource.url}`);
      setMediaData(oneSource);
      toggle_MediaPop();
      return;
    }
    if (isNum) {
      customRedirect(`./textdetail?id=${oneSource?.url}`);
    } else {
      window.open(oneSource?.url);
    }
  };
  const onSaveImg = (oneSource) => {
    logDownPic(oneSource.title);
    downloadImage(oneSource.image, oneSource.title);
  };

  if (isLimit) {
    return <DomainLimit />;
  }
  return (
    <BaseContainer>
      <Header />
      <div styleName="media_list_banner">
        <span className={getSpecFont(i18n.language)}>{t('press')}</span>
      </div>
      <div styleName="media_list_contain">
        <div styleName="media_tab_wrap">
          <div styleName="media_packing">
            {mediaListTab.map((item, idx) => {
              return (
                <div
                  styleName={`media_tab ${idx === currentTabIndex ? `tab_list${idx}` : ''}`}
                  className={getSpecFont(i18n.language, false)}
                  key={idx}
                  onClick={() => handleSelectTab(item, idx)}
                >
                  {mediaLabels[item] || item}
                </div>
              );
            })}
          </div>
        </div>
        {/* tab内容区 */}
        <div styleName="media_change_contain">
          {onProcessData()?.map((item, index) => {
            return (
              <div
                key={index}
                styleName="process_list_width"
                style={{ display: item.titleList.length > 0 ? 'block' : 'none' }}
              >
                <div styleName="logos_wrap">
                  <div styleName="logos_text" className={getSpecFont(i18n.language)}>
                    {mediaLabels[item.title] || item.description}
                  </div>
                </div>
                {/* 列表 */}

                <div
                  styleName="module_list"
                  style={{
                    height:
                      currentTabName === 'ALL'
                        ? '3.82rem'
                        : `${Math.ceil(item?.titleList?.length / 3) * 3.82}rem`
                  }}
                >
                  {item?.titleList.map((curTitleList, curIdx) => {
                    return (
                      <div styleName="module_wrap" key={curIdx}>
                        <div styleName="module_bg" onClick={() => handleOnUrl(curTitleList)}>
                          <img src={curTitleList?.image} alt="" />
                        </div>
                        <div styleName="module_desc">{curTitleList?.title}</div>
                        <div styleName="module_size">
                          {curTitleList.description !== 'VIDEOS' && curTitleList.url === '' && (
                            <span
                              onClick={() => onSaveImg(curTitleList)}
                              className={getSpecFont(i18n.language)}
                            >
                              {t('download')}
                              <i></i>
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div styleName="media_list_foot"></div>
      <ShowMediaPop classNames="scale">
        <MediaPop mediaData={mediaData} />
        <CloseMediaPop styleName="close_rule" />
      </ShowMediaPop>

      <Footer />
    </BaseContainer>
  );
}
